const ExternalLink = {
  DEFECT_EMPTY_STATE_MEDIA: 'https://demo.arcade.software/6vRfjsw8PYZphnqgEVeY?embed',
};

export default ExternalLink;
